const API_URL = "https://resume-ai-11.onrender.com"; // Django backend URL
export default API_URL;
